<template>

	<div class="control is-horizontal section-header">

		<div class="control-label">
			<h3 class="section-header__title">
				<slot name="title">
					<lang :labelKey="title" v-if="title"></lang>
				</slot>
			</h3>
		</div>

		<div class="control section-header__content">
			<slot></slot>
		</div>

	</div>

</template>


<script>
export default {

	name: 'equipmentSectionHeader',

	props: {
		title: {
			type: String,
			default: ''
		}
	}

}
</script>


<style lang="scss" scoped>

.section-header {

	align-items: center;
	margin-top: 30px;
	margin-bottom: 20px;

	&:first-child {
		margin-top: 0;
	}

	.control-label {
		align-self: center;
		text-align: right;
	}

	.section-header__title {
		margin: 0 0 0 auto;
		font-size: 16px;
		font-weight: 600;
		color: #333;
		margin: 0;
		line-height: 1.3;
		text-transform: uppercase;
		letter-spacing: 0.03em;
	}

	.section-header__content {
		display: flex;
		align-items: center;
	}

}

</style>
